export default {
	title: 'Firmenlauf Potsdam',
	gsmaterials: {
		app: {
			scrollTop: {
				offset: 250,
				size: 'lg',
				icon: 'i-mdi-chevron-up',
				class: 'z-20',
				color: 'primary',
				variant: 'solid'
			},
		}
	},
	ui: {
		carousel: {
			 variants: {
				 active: {
					 true: {
						 dot: 'bg-accent! size-4'
					 }
				 }
			 },
			compoundVariants: [
				{
					color: 'white',
					variant: 'link',
					class: 'text-white hover:accent'
				},
			]
		}
	}
}
